import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import './styles.css';
import MemorialPage from './MemorialPage';
import ProfileDirectory from './ProfileDirectory';
import ProjectionPage from './ProjectionPage';
import AddMemoryPage from './AddMemoryPage';
import MemoryDetailPage from './MemoryDetailPage';
import { ROMAN_SLUG } from './memoryUtils';

const ProfileAdmin = lazy(() => import('./ProfileAdmin'));
const ControlPanel = lazy(() => import('./ControlPanel'));
const MyMemories = lazy(() => import('./MyMemories'));

export default function App() {
  return (
    <BrowserRouter>
      <div id="app-container">
        <div id="main-content">
          <Suspense fallback={<p className="site-shell site-status">Načítám…</p>}>
            <Routes>
              <Route path="/" element={<ProfileDirectory />} />
              <Route path="/roman-pt" element={<Navigate to="/mgr-Roman-Kalab-Riha-2024-30-11" replace />} />
              <Route path="/mgr-Roman-Kalab-Riha-2024-30-11" element={<MemorialPage profileSlug={ROMAN_SLUG} />} />
              <Route path="/mgr-Roman-Kalab-Riha-2024-30-11/vzpominka/:memoryId" element={<MemoryDetailPage />} />
              <Route path="/mgr-Roman-Kalab-Riha-2024-30-11/add" element={<AddMemoryPage profileSlug={ROMAN_SLUG} />} />
              <Route path="/p/:profileSlug/add" element={<AddMemoryPage />} />
              <Route path="/p/:profileSlug" element={<MemorialPage />} />
              <Route path="/p/:profileSlug/admin" element={<ProfileAdmin />} />
              <Route path="/p/:profileSlug/prispevky" element={<MyMemories />} />
              <Route path="/p/:profileSlug/projekce" element={<ProjectionPage />} />
              <Route path="/p/:profileSlug/vzpominka/:memoryId" element={<MemoryDetailPage />} />
              <Route path="/slideshow" element={<ProjectionPage ceremony />} />
              <Route path="/control" element={<ControlPanel />} />
              <Route
                path="*"
                element={
                  <main className="site-shell site-status">
                    <h1>Stránka nebyla nalezena</h1>
                    <a href="/">Vzpomínkovník</a>
                  </main>
                }
              />
            </Routes>
          </Suspense>
        </div>
      </div>
    </BrowserRouter>
  );
}
